//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      events: null,
      childViews: null
    };
  },
  methods: {
    $ready: function $ready() {
      this.events = this.spec.events;
      this.childViews = this.spec.childViews;
    },
    iconSize: function iconSize() {
      return this.$classes().includes("small") ? 16 : 24;
    }
  }
};